<template>
  <span class="m12">{{ amount | amountInWords }}</span>
</template>

<script >
export default {
  props:{
    amount:''
  }
}
</script>

<style scoped>
.m12{
  margin-left: 12px;
  color: #ff6e6e;
}
</style>